/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Option/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Option({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/PatientOptions/Existing/Content/LocationSelect/Content/Content/Content/Option",
  closePopover
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let tabSelectedLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.location_id',
})
let itemIdValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: '_id',
})
let aggregateData = fromAggregate.equals(tabSelectedLocationIdValueData, itemIdValueData)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  closePopover,
  isHovered
  
})
let itemNameValueData = fromData.useDataValue({ viewPath,
context: 'item',
path: 'name',
})
  return (<React.Fragment
>
<button
  data-testid="Option.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 closePopover={closePopover}
 style={{'--pl-1-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-Z2h7tiu': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-3-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-4-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-5-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-6-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bblr-7-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-8-Z2h7tiu': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-9-Z2h7tiu': isHovered ? dtColorsNeutral200 : aggregateData ? dtColorsNeutral200 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="item.name"
 text={itemNameValueData}
/>
</button>
{children}
</React.Fragment>)
}